import { style } from 'typestyle'
export const p16 = style({ padding: '16px' })
